const PARAMETER_ATTRIBUTES = "attrib";
const PARAMETER_PAGE = "page";
const PARAMETER_SORTING = "sorting";
const PARAMETER_ITEMS = "items";
const PARAMETER_CATEGORY = "plentyMarkets";
const PARAMETER_FACET = "facets";
const PARAMETER_QUERY = "query";
const PARAMETER_CACHE_BLOCK = "plentyCacheBlockSSR";
const PARAMETER_CACHE_BLOCK_ID = "plentyCacheBlockId";

export default {
    PARAMETER_ATTRIBUTES: PARAMETER_ATTRIBUTES,
    PARAMETER_PAGE: PARAMETER_PAGE,
    PARAMETER_SORTING: PARAMETER_SORTING,
    PARAMETER_ITEMS: PARAMETER_ITEMS,
    PARAMETER_CATEGORY: PARAMETER_CATEGORY,
    PARAMETER_FACET: PARAMETER_FACET,
    PARAMETER_QUERY: PARAMETER_QUERY,
    PARAMETER_CACHE_BLOCK,
    PARAMETER_CACHE_BLOCK_ID
};
